<template>
  <div class="c-o-search-sidebar c-o-search-sidebar--mobile">
    <div class="c-o-search-sidebar__toggle-wrapper">
      <p class="c-o-search-sidebar__toggle-heading">{{ activeFilters }}</p>
      <atom-button class="c-o-search-sidebar__toggle" :modifiers="'c-a-button--theme-primary '"
        :label="filterToggled ? 'Dölj alla filter' : 'Visa alla filter'" :icon="'expand_more'"
        :class="{ 'c-o-search-sidebar__toggle--toggled': filterToggled }" @buttonClicked="toggleFilter"></atom-button>
    </div>
    <div class="c-o-search-sidebar__inner" :class="{ 'c-o-search-sidebar__inner--active': filterToggled }">
      <div class="c-o-search-sidebar__block">
        <geo-location-search label="Kommun" :placeholder="'Ex. Uppsala'" v-model="region" :regionIsSet="paramRegion"></geo-location-search>
      </div>
      <div class="c-o-search-sidebar__block">
        <drilldown :items="categories" :defaultValue="searchParams.categories" :label="'Kategori'"
          :placeholder="'Sök efter en kategori'" v-model="category"></drilldown>
      </div>
      <div class="c-o-search-sidebar__block">
        <atom-select :alternatives="certificatesOptions" :label="'Certifikat'" :id="'certificate'" :icon="'certificate'"
          v-model="certModel" :placeholder="'Välj ett certifikat'"></atom-select>
      </div>
      <div class="c-o-search-sidebar__block">
        <atom-input-search :label="'Sök efter hantverkare'" :name="'company-search'"
          :placeholder="'Ex. Anderssons Bygg AB'" :searchFunction="pushSearchUrl"
          v-model="queryString"></atom-input-search>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  FETCH_COMPANIES,
  SET_CATEGORY_ACTION,
  SET_CERTIFICATE_ACTION,
  SET_QUERY_ACTION,
  SET_REGION_ACTION,
  GET_COMPANIES,
  GET_SEARCH_PARAMS,
  IS_LOADING,
  GET_ERROR
} from "../../../../store/store-models/companies-model";

import {
  FETCH_FILTERS,
  GET_CATEGORIES,
  GET_CERTIFICATES,
  GET_REGIONS
} from "../../../../store/store-models/filters-model";

import AtomButton from "../../atoms/AtomButton.vue";
import AtomSelect from "../../atoms/form/AtomSelect.vue";
import Drilldown from "../../atoms/form/AtomDrilldownCategoriesSearch.vue";
import GeoLocationSearch from "../../atoms/form/AtomInputAutocompleteRegion.vue";
import AtomInputSearch from "../../atoms/form/AtomInputSearch.vue";

export default {
  components: {
    AtomButton,
    AtomSelect,
    Drilldown,
    GeoLocationSearch,
    AtomInputSearch
  },
  data() {
    return {
      filterToggled: false
    };
  },
  props: ['paramRegion'], 
  computed: {
    ...mapGetters({
      companies: GET_COMPANIES,
      searchParams: GET_SEARCH_PARAMS,
      isLoading: IS_LOADING,
      error: GET_ERROR,
      regions: GET_REGIONS,
      categories: GET_CATEGORIES,
      certificates: GET_CERTIFICATES
    }),
    nrOfCompanies: function () {
      return !this.isLoading ? this.companies.meta.count : 0;
    },
    activeFilters: function () {
      let chosenRegion = this.searchParams.region;
      let chosenCategory = this.searchParams.category;
      let chosenCertificate = this.searchParams.certid;

      const filterArr = [chosenRegion, chosenCategory, chosenCertificate];
      let activeItems = [];
      activeItems = filterArr.filter(filter => {
        return filter ? true : false;
      });

      if (activeItems.length === 1) {
        return `${activeItems.length} filter aktivt`;
      } else {
        return `${activeItems.length} filter aktiva`;
      }
    },
    certificatesOptions: function () {
      const arr = [];

      if (this.certificates && this.certificates.length > 0) {
        this.certificates.forEach(cert => {
          if(cert.CertID === 30) return;
          arr.push({
            value: cert.CertID,
            text: cert.Name
          });
        });
      }

      return arr;
    },
    region: {
      get: function () {
        return this.searchParams.region;
      },
      set: function (val) {
        if (val) {
          this.setRegion(val);

        } else {
          this.setRegion(null);
        }
        this.pushSearchUrl();
      }
    },
    category: {
      get: function () {
        return this.searchParams.category;
      },
      set: function (val) {
        this.setCategory(val);
        this.pushSearchUrl();
      }
    },
    certModel: {
      get: function () {
        return this.searchParams.certid;
      },
      set: function (val) {
        this.setCert(val);
        this.fetchCompanies();
      }
    },
    queryString: {
      get() {
        return this.searchParams.q;
      },
      set(val) {
        this.setQuery(val);
      }
    }
  },
  methods: {
    ...mapActions({
      fetchCompanies: FETCH_COMPANIES,
      fetchFilters: FETCH_FILTERS,
      setCert: SET_CERTIFICATE_ACTION,
      setRegion: SET_REGION_ACTION,
      setCategory: SET_CATEGORY_ACTION,
      setQuery: SET_QUERY_ACTION
    }),
    toggleFilter() {
      if (this.filterToggled === true) {
        this.filterToggled = false;
      } else {
        this.filterToggled = true;
      }
    },
    pushSearchUrl() {
      let routeName = "HantverkareFilter";

      const params = {};
      const query = {};

      if (!this.category && !this.region) {
        routeName = "Sök hantverkare";
      } else {
        params["region"] =
          this.region && this.region.URLName ? this.region.URLName : "alla";

        params["category"] =
          this.category && this.category.URLName ? this.category.URLName : null;
      }

      if (this.queryString) {
        query["q"] = this.queryString;
      }

      this.$router.push({
        name: routeName,
        params,
        query
      });
    },

  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/search/OrganismSearchSidebarCompanies.vue